import styled from 'styled-components'
import { TopContainerHeight } from '~/constants'

export const ContainerOncology = styled.div`
  position: relative;
  flex: 1;
  height: calc(100vh - ${TopContainerHeight});
  padding: 40px 10px 10px;

  display: flex;
  flex-direction: column;
  gap: 1rem;
  overflow: hidden;
`
